// extracted by mini-css-extract-plugin
export default {"input":"styles_input__XG3Yf","switch":"styles_switch__ugFDf","label":"styles_label__q7TGA","active":"styles_active__qUjJS"};